import { Alert, Col, Row } from 'react-bootstrap';

export default function UnauthorizedPage() {
  return (
    <Row className="justify-content-md-center">
      <Col sm={6} className="text-center">
        <Alert variant="warning">Not authorized to view this page.</Alert>
      </Col>
    </Row>
  );
}